/**
 * Камера-сканер, загружаемая по требованию — ОДНО объявление на портал.
 *
 * ⚠️ Через `lazyChunk`, а не голый `React.lazy`: вкладку склада не закрывают
 * сутками, деплой меняет хэши чанков, и старый файл отдаёт честный 404 — белый
 * экран ровно в момент нажатия «Сканировать».
 *
 * ⚠️ Объявление было скопировано в ДЕВЯТЬ экранов слово в слово. Ничего
 * страшного оно не делало, но цена копий вскрылась на переезде: камера сменила
 * папку, и проверка, следящая за правильным подключением, осталась смотреть на
 * прежний адрес — то есть замолчала. Одно объявление такого шанса не даёт.
 *
 * Импортировать ТОЛЬКО отсюда: статический импорт из самого модуля камеры
 * утянет распознаватель в основной бандл и молча убьёт ленивую загрузку
 * (замерено — +54 КБ, отдельного чанка не остаётся).
 */
import { lazyChunk } from "@/lib/lazy-chunk";

export const CameraScanner = lazyChunk(() =>
  import("@/lib/scan-ui/CameraScanner").then((m) => ({ default: m.CameraScanner })),
);
